import { TriangleDownIcon, TriangleUpIcon } from "@radix-ui/react-icons"
import classNames from "classnames"

import styles from "./CancelsTableView.module.scss"

import {
	CANCEL_SORT_KEY_LABEL,
	CANCEL_SORT_ORDER_LABEL,
	CancelSortKey,
	CancelSortState,
} from "../useCancelSort"

/** ヘッダーの表示テキスト。sortKey があるヘッダーはクリックで並び替えできる */
export type TableHeader = {
	/** 折り返して2行で見せたいので配列で持つ */
	lines: string[]
	sortKey?: CancelSortKey
}

type Props = {
	headers: TableHeader[]
	/** 現在のタブで並び替えに使えるキー。ここに無い sortKey は普通のヘッダーとして描画する */
	sortableKeys: CancelSortKey[]
	sort: CancelSortState
	onClickSortKey: (key: CancelSortKey) => void
}

/**
 * キャンセル一覧テーブルのヘッダーセル群 (先頭のチェックボックス列は含まない)。
 *
 * 並び替え可能なヘッダーは、クリックできると分かるように常に上下の三角を出しておき、
 * 選択中の向きだけブランドカラーで塗る。
 */
export const CancelsTableHeaderCells = ({
	headers,
	sortableKeys,
	sort,
	onClickSortKey,
}: Props) => {
	return (
		<>
			{headers.map((header, index) => {
				const sortKey = header.sortKey
				const label = header.lines.map((text, i) => <div key={i}>{text}</div>)

				if (sortKey === undefined || !sortableKeys.includes(sortKey)) {
					return <th key={index}>{label}</th>
				}

				const currentOrder =
					sort !== null && sort.key === sortKey ? sort.order : null
				return (
					<th
						key={index}
						className={classNames(styles.sortable_header, {
							[styles.sorted]: currentOrder !== null,
						})}
						aria-sort={
							currentOrder === "ASC"
								? "ascending"
								: currentOrder === "DESC"
									? "descending"
									: "none"
						}
					>
						<button
							type="button"
							className={styles.sort_button}
							title={`${CANCEL_SORT_KEY_LABEL[sortKey]}で並び替え`}
							onClick={() => onClickSortKey(sortKey)}
						>
							<span className={styles.sort_button_label}>{label}</span>
							<span className={styles.sort_arrows}>
								<TriangleUpIcon
									className={classNames(styles.sort_arrow, {
										[styles.active]: currentOrder === "ASC",
									})}
								/>
								<TriangleDownIcon
									className={classNames(styles.sort_arrow, {
										[styles.active]: currentOrder === "DESC",
									})}
								/>
							</span>
						</button>
						{currentOrder !== null && (
							<div className={styles.sort_order_label}>
								{CANCEL_SORT_ORDER_LABEL[currentOrder]}
							</div>
						)}
					</th>
				)
			})}
		</>
	)
}

export default CancelsTableHeaderCells
